import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import BackButton from "../common/BackButton";

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubOpen, setIsSubOpen] = useState(false);
  const [pdfReady, setPdfReady] = useState(false);
  const [statusData, setStatusData] = useState(null);
  const [mypageData, setMypageData] = useState(null);

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const closeHamburger = () => setIsOpen(false);
  const toggleHamburger = () => setIsOpen(prev => !prev);

  const isConfirmed = (data) => {
    if (!data) return false;
    return data.r1_host_status === "確認済";
  };

  const isConfirmedOp = (data) => {
    if (!data) return false;
    const validStatuses = ["確認済", "申請しない"];
    return (
      validStatuses.includes(data.o8_host_status) &&
      validStatuses.includes(data.o4_host_status)
    );
  };

  const canDownload =
    pdfReady &&
    isConfirmed(statusData) &&
    isConfirmedOp(statusData);

  const pdfItems = [
    // { label: 'INDEX', path: '/INDEX.pdf' },
    { label: '出展規定', path: '/出展規定.pdf' },
    { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
    { label: '色見本', path: '/色見本.pdf' },
    { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
    { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
    { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
    { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
    { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
    { label: '小間図面', path: '/小間図面.pdf' },
    { label: '素材集', path: '/素材集.zip' },
    // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
    // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
    // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
    // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
    // { label: '出展者一覧', path: '/出展者一覧.pdf' },
    // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
    // { label: '運送関連', path: '/運送関連.zip' },
    // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
    // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res1 = await api.get(`/api/mypage/${user.mypage_id}`);
        const res2 = await api.get(`/api/submission-status/${user.mypage_id}`);
        setMypageData(res1.data);
        setStatusData(res2.data);
      } catch (err) {
        console.error(err);
      }
    };
    if (user?.mypage_id) fetchData();
  }, []);

  useEffect(() => {
    if (!mypageData?.exhibitor_id) return;

    api.get(`/api/pdf-exists/${mypageData.exhibitor_id}`)
      .then(res => setPdfReady(res.data.exists))
      .catch(() => setPdfReady(false));
  }, [mypageData]);

  const handlePdfDownload = async () => {
    if (!canDownload) return;

    try {
      const res = await api.get(
        `/api/pdf-download/${mypageData.exhibitor_id}`,
        { responseType: "blob" }
      );

      const blob = new Blob([res.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${mypageData.company_name}_pdfs.zip`;
      link.click();

      closeHamburger();
    } catch (e) {
      alert("ダウンロード失敗");
    }
  };

  const handleNav = (path) => {
    navigate(path);
    closeHamburger();
  };

  return (
    <>
      {/* ボタン */}
      <style>
        {`
        .hamburger_menu_btn_wrap {
        margin-right: 12px;
        position: fixed;
        right: 0;
        top: 20px;
        z-index: 1100;
        }

        .hamburger_menu_btn {
        width: 32px;
        height: 24px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        }

        .hamburger_menu_btn span {
        display: block;
        width: 100%;
        height: 3px;
        background: #0a4bc1;
        border-radius: 3px;
        transition: 0.3s;
        }

        /* アニメーション */
        .hamburger_menu_btn.active span:nth-child(1) {
        transform: translateY(10px) rotate(45deg);
        }
        .hamburger_menu_btn.active span:nth-child(2) {
        opacity: 0;
        }
        .hamburger_menu_btn.active span {background: #fff;}
        .hamburger_menu_btn.active span:nth-child(3) {
        transform: translateY(-10px) rotate(-45deg);
        }

        /* 背景 */
        .hamburger_background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        backdrop-filter: blur(4px);
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        transition: 0.3s;
        }

        .hamburger_background.open {
        opacity: 1;
        visibility: visible;
        }

        /* メニュー本体 */
        .hamburger_window {
        position: fixed;
        top: 0;
        right: 0;
        width: 75%;
        max-width: 320px;
        height: 100vh;
        background: rgba(0,0,0,0.5);
        box-shadow: -5px 0 20px rgba(0,0,0,0.2);
        z-index: 1000;

        transform: translateX(100%);
        transition: 0.35s ease;
        }

        .hamburger_window.open {
        transform: translateX(0);
        }

        /* 閉じるボタン */
        .hamburger_close_btn {
        background: none;
        border: none;
        color: white;
        font-size: 28px;
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
        }

        /* メニュー */
        .hamburger_list_item {
        list-style: none;
        padding: 80px 0 0;
        margin: 0;
        }

        .hamburger_list_item li {
        padding: 16px 24px;
        color: white;
        font-size: 1.1rem;
        border-bottom: 1px solid rgba(255,255,255,0.1);
        cursor: pointer;
        transition: 0.2s;
        }

        /* hover気持ちよく */
        .hamburger_list_item li:hover {
        background: rgba(255,255,255,0.1);
        padding-left: 30px;
        }

        /* サブメニュー */
        .hamburger_list_item ul {
        padding-left: 15px;
        background: rgba(255,255,255,0.05);
        }

        .hamburger_list_item ul li {
        font-size: 0.95rem;
        opacity: 0.85;
        }

        .list-none {list-style: none;padding-left: 0;margin-top: 50px;}

        /* スマホ表示 */
        @media (max-width: 560px) {
        .sm-block { display: block; }
        .menu-item {background-color: #fff;margin-bottom: 10px;}
        }

        @media (min-width: 561px) {
        .hamburger_menu_btn_wrap { display: none; }
        }
        `}
       </style>
      <div className="hamburger_menu_btn_wrap sm-block">
        <div
          className={`hamburger_menu_btn ${isOpen ? "active" : ""}`}
          onClick={toggleHamburger}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* 背景 */}
      {isOpen && (
        <div
          className="hamburger_background open"
          onClick={closeHamburger}
        />
      )}

      {/* メニュー */}
      <div className={`hamburger_window ${isOpen ? "open" : ""}`}>
        <ul className="list-none">
          <li className="menu-item" onClick={() => handleNav(user?.mypage_url)}>TOP</li>

          <li className="menu-item" onClick={() => handleNav(`/mypage-info/${user?.exhibitor_id}`)}>
            出展者情報編集
          </li>

          <li
            onClick={handlePdfDownload}
            style={{
              opacity: canDownload ? 1 : 0.5
            }}
            className="menu-item"
          >
            見積書発行
          </li>

          <li className="menu-item" onClick={() => handleNav("/mail-form/")}>
            お問い合わせ
          </li>

          {/* 👇 サブメニュー */}
          <li>
            <div onClick={() => setIsSubOpen(prev => !prev)} className="menu-item">
              資料ダウンロード
            </div>

            {isSubOpen && (
              <ul>
                {pdfItems.map((item, i) => (
                  <li key={i}>
                    <a href={item.path} download>
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>

          <li className="menu-item" onClick={() => handleNav(user?.mypage_url + "#news")}>
            お知らせ
          </li>
          <li
            className="menu-item"
            onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
          >
            個人情報保護方針
          </li>
        </ul>
      </div>
      <BackButton/>
    </>
  );
};

export default HamburgerMenu;